import { TFunction } from 'react-i18next';

export type Unit = 'day' | 'month';

const DAYS_PER_WEEK = 7;
const MONTHS_PER_YEAR = 12;

/**
 * Formats billing interval
 * @param {number} interval - billing interval
 * @param {Unit} unit - billing unit
 * @param {any} t - translation function from react-i18next
 * @returns {string} formatted billing interval
 */
export const formatBillingInterval = (
  interval: number,
  unit: Unit,
  t: TFunction<'common'[]>
) => {
  if (interval < 1) return;

  const UNIT_INTERVAL_MAP = {
    day: t('interval.daily'),
    week: t('interval.weekly'),
    month: t('interval.monthly'),
    year: t('interval.annually'),
    quarter: t('interval.quarterly'),
  };

  if (interval === 1) {
    return UNIT_INTERVAL_MAP[unit];
  }

  if (interval === 7 && unit === 'day') return UNIT_INTERVAL_MAP['week'];
  if (interval === 3 && unit === 'month') return UNIT_INTERVAL_MAP['quarter'];
  if (interval === 12 && unit === 'month') return UNIT_INTERVAL_MAP['year'];

  if (unit === 'day' && interval % DAYS_PER_WEEK === 0) {
    const numberOfWeeks = interval / DAYS_PER_WEEK;
    return `${t('interval.every')} ${numberOfWeeks} ${t('interval.week', {
      count: numberOfWeeks,
    })}`;
  }

  if (unit === 'month' && interval % MONTHS_PER_YEAR === 0) {
    const numberOfYears = interval / MONTHS_PER_YEAR;
    return `${t('interval.every')} ${numberOfYears} ${t('interval.year', {
      count: numberOfYears,
    })}`;
  }
  return `${t('interval.every')} ${interval} ${t('interval.' + unit, {
    count: interval,
  })}`;
};
